import { Modal, Button, Tabs, Tab } from "react-bootstrap";

const LegalModal = ({ show, onHide }) => {
  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Юридическая информация</Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
        <Tabs defaultActiveKey="privacy" className="mb-3">

          {/* ================= PRIVACY POLICY ================= */}
          <Tab eventKey="privacy" title="Политика конфиденциальности">
            <h5>1. Общие положения</h5>
            <p>
              Компания <strong>Plotepus</strong> уважает право пользователей на
              конфиденциальность и обеспечивает защиту персональных данных в
              соответствии с действующим законодательством.
            </p>

            <h5>2. Какие данные мы собираем</h5>
            <ul>
              <li>Имя и контактные данные (телефон, e-mail)</li>
              <li>Информацию, предоставленную пользователем добровольно</li>
              <li>Технические данные (IP, cookies, тип устройства)</li>
            </ul>

            <h5>3. Цели обработки данных</h5>
            <ul>
              <li>Обработка заявок и обратная связь</li>
              <li>Консультации и оказание услуг</li>
              <li>Улучшение качества сервиса</li>
            </ul>

            <h5>4. Передача данных третьим лицам</h5>
            <p>
              Plotepus не передает персональные данные третьим лицам без согласия
              пользователя, за исключением случаев, предусмотренных законом.
            </p>

            <h5>5. Защита информации</h5>
            <p>
              Мы применяем организационные и технические меры для защиты данных
              от несанкционированного доступа, утраты или изменения.
            </p>

            <h5>6. Контакты</h5>
            <p>
              По вопросам обработки персональных данных вы можете обратиться по
              адресу: <strong>office@plotepus.com</strong>
            </p>
          </Tab>

          {/* ================= TERMS OF USE ================= */}
          <Tab eventKey="terms" title="Пользовательское соглашение">
            <h5>1. Общие положения</h5>
            <p>
              Настоящее соглашение является публичной офертой компании{" "}
              <strong>Plotepus</strong> (далее — «Исполнитель»).
            </p>
            <p>
              Пользователь, оставляя заявку или оплачивая услуги, принимает
              условия настоящего соглашения в полном объёме.
            </p>

            <h5>2. Предмет договора</h5>
            <p>
              Исполнитель предоставляет информационные и консультационные услуги,
              направленные на анализ ситуации и сопровождение процессов,
              связанных с возвратом денежных средств.
            </p>

            <h5>3. Условия оказания услуг</h5>
            <ul>
              <li>Услуги оказываются дистанционно</li>
              <li>Формат и объем услуг определяются индивидуально</li>
              <li>
                Исполнитель не гарантирует результат, если иное не согласовано
                отдельно
              </li>
            </ul>

            <h5>4. Оплата</h5>
            <p>
              Условия оплаты определяются индивидуально. В ряде случаев услуги
              оказываются без предоплаты и оплачиваются по факту достижения
              результата.
            </p>

            <h5>5. Ответственность сторон</h5>
            <p>
              Исполнитель не несет ответственности за действия третьих лиц,
              включая банки, брокеров и платёжные системы.
            </p>

            <h5>6. Заключительные положения</h5>
            <p>
              Все споры решаются путем переговоров, а при невозможности —
              в соответствии с применимым законодательством.
            </p>

            <h5>Контакты</h5>
            <p>
              Все обращения и уведомления направляются на:
              <br />
              <strong>office@plotepus.com</strong>
            </p>
          </Tab>

        </Tabs>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Закрыть
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default LegalModal;